import axios from 'axios'

const userContext = require('./userContext')

const httpClient = axios.create()

httpClient.interceptors.request.use(
  function (config) {
    // 统一在这里注入 userId header，避免散落到每个 API 方法手写 headers。
    config.headers = userContext.buildUserContextHeaders(config.headers || {})
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default httpClient
